import { IPlanarFolder } from "../../pages/dashboardPage/components/fullAnalysis/FSPlanarize";
import { IAnalysisFolder } from "../../pages/dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { IFileProvider } from "./IFileProvider";
import { GFileProvider } from "./gFileProvider";
import { ServerFileProvider } from "./serverProvider";
import { goLink } from "../../utils/goLink";
import { AnalysisProvider } from "./analysisProvider";
import { DesktopProvider } from "./desktopProvider";

const providerMap = {
    'g': GFileProvider,
    'analysis': AnalysisProvider
}

export class MultiFileProvider implements IFileProvider{
    public onChange: (provider: IFileProvider)=>void;
    public onReady: ()=>void;
    public onAuthError?: (error: any) => void;
    //public crumbs: Array<IAnalysisFolder> = [];
    public fileProviders: Array<IFileProvider> = [];
    //private folders: Array<IPlanarFolder>;

    constructor(private InitialProvider: {new ():IFileProvider}){
        Promise.resolve(true).then(()=>this.onReady?.());
    }

    get providerName(){
        return this._lastProvider()?.providerName;
    }

    async connect(){
        return this._lastProvider().connect();
    }

    get crumbs(){
        return this._allCrumbs();
    }

    private _fileById = (id: string)=>{
        return this._lastCrumb().folderItems?.find(it=>it.id == id);
    }

    private _lastCrumb = ()=>{
        return this.crumbs[this.crumbs.length - 1];
    }

    private _lastProvider = ()=>{
        return this.fileProviders[this.fileProviders.length - 1];
    }

    private _allCrumbs = ()=>{
        const crumbs: IAnalysisFolder[] = [];
        this.fileProviders.forEach(provider=>{
            provider.crumbs.forEach(it=>{
            crumbs.push(it); 
            })    
        });
        return crumbs;
    }

    private _handleCrumb = (folderId: string, aliasName:string)=>{
        let crumbProviderIndex = this.fileProviders.findIndex(provider=>{
            return provider.crumbs.findIndex(it=>it.id == folderId) !=-1;
        });
        /*if (crumbProviderIndex == -1){
            crumbProviderIndex = 0;
        }*/
        const crumbProvider = this.fileProviders[crumbProviderIndex];
        this.fileProviders = this.fileProviders.slice(0, crumbProviderIndex + 1);
        crumbProvider.getFiles(folderId, aliasName);
    }

    private _selectFolder = (folder: IAnalysisFolder)=>{
        const fileProvider = this._lastProvider();
        if (folder.type == 'folder'){
            return fileProvider.getFiles(folder.id);
        } else
        if (folder.type == 'file'){
            if (this._lastProvider().providerName ==  'g'){
                goLink(`https://drive.google.com/file/d/${folder.id}/view`);
            } else {
                return fileProvider.getFiles(folder.id);
            }
        } else
        if (folder.type == 'fileLink' && folder.linkProvider !='analysis'){
            if (folder.linkProvider == 'g'){
                goLink(`https://drive.google.com/file/d/${folder.link}/view`);
            }
        } else
        if (folder.type == 'folderLink' || (folder.type == 'fileLink' && folder.linkProvider =='analysis')){
            const ProviderConstructor = providerMap[folder.linkProvider as keyof typeof providerMap];
            const provider = new ProviderConstructor();
            provider.onChange = ()=>{
                console.log('google fp changed - ', folder.link);
                this.onChange(this);
                //setFix(last=>last+1);
            }
            provider.onAuthError = (err)=>{
                this.onAuthError?.(err);
            }
            //setFileProviders(last=>[...last, provider]);
            this.fileProviders.push(provider);
            return provider.getFiles(folder.link, folder.name);
        }
        //setCrumbs(last=>[...last, folder]);
    }

    async getFiles(folderId?: string, aliasName?: string, restoreCrumbs?: Array<IAnalysisFolder>){
        if (this.fileProviders.length == 0){
            const provider = new this.InitialProvider();//new ServerFileProvider(this.rootId, this.rootName);
            if (restoreCrumbs){
                provider.crumbs = restoreCrumbs;
            }
            provider.onChange = ()=>{
                this.onChange(this);
                //setFix(last=>last+1);
            }
            //setFileProviders(last=>[...last, provider]);
            this.fileProviders.push(provider);
        }
        if (!folderId && this.fileProviders.length == 1){
            return this._lastProvider().getFiles();
        };
        const crumbIndex = this._allCrumbs().findIndex(it=>it.id == folderId);
        if (crumbIndex == -1){
            const folder = this._fileById(folderId);
            this._selectFolder(folder);
        } else if (crumbIndex == this._allCrumbs().length -1){
            this._lastProvider().getFiles(folderId, aliasName);
        } else {
            //const folder = this._fileById(folderId);
            this._handleCrumb(folderId, aliasName);
        }
    }

    async createFile(file: File, folderId: string, onProgress?: (loaded: number, total: number)=>void){
        return this._lastProvider().createFile(file, folderId, onProgress);
    }

    async createFolder(folder: IAnalysisFolder, folderId: string){
        return this._lastProvider().createFolder(folder, folderId);
    }

    async updateFile(fileData: IAnalysisFolder){
        return this._lastProvider().updateFile(fileData);
    }

    async deleteFile(fileId: string){
        return this._lastProvider().deleteFile(fileId);
    }
    
}